import React from "react";
import { graphql } from "gatsby";
import PageLayout from "../components/PageLayout";
import Section from "../components/Section";
import Container from "../components/Container";
import PageHeader from "../components/PageHeader";
import { Component } from "../components/FlexibleComponents/Component";

export default function Page({ data: { page, site } }) {
  const components = page.components.components;

  let showPageTitle = true;
  if (page.isFrontPage) {
    showPageTitle = false
  }
  if (page.pageHeading.hide) {
    showPageTitle = false
  }

  return (
    <PageLayout
      seo={page}
      breadcrumbs={page.seo.breadcrumbs}
      disableSubscribeToNewsletter={page.pageSettings?.disableGlobalSubscribeToNewsletterComponent}
      useSsss={page.pageSettings?.useSsss}
    >
      {showPageTitle && (
        <Section>
          <Container>
            <PageHeader
              title={page.title}
              noSpace
              center={page.pageHeading?.centerHeading}
            />
          </Container>
        </Section>
      )}
      {components
        ? components.map((component, index) => (
            <Component component={component} source={page.uri} key={index} />
          ))
        : `No content`}
    </PageLayout>
  );
}

export const query = graphql`
  query ($id: String!) {
    page: wpPage(id: {eq: $id}) {
      ...PageFields
    }
  }
`;
